import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MediaOutline } from '@bonusly/design-system';

import { AttachmentCategory, useActionInput } from '../../';
import { useFileSelector } from '../../hooks/use-file-selector';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { DecorationButton } from './decoration-button';

export const AttachmentButton: FC = () => {
	const { attachment } = useActionInput();
	const isEnabled = useIsEnabled('attachment');
	const openFileSelector = useFileSelector({
		allowedExtensions: ['avi', 'jpg', 'jpeg', 'mov', 'mp4', 'png', 'gif', 'webm', 'wmv'],
	});
	const { t } = useTranslation('action_input');

	if (!isEnabled) {
		return null;
	}

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.currentTarget.blur(); // Remove focus from button
		// eslint-disable-next-line
		if (attachment?.category === AttachmentCategory.Video && !confirm(t('decorations.upload_attachment_warning'))) return;
		openFileSelector();
	};

	return (
		<DecorationButton label={t('decorations.upload_attachment_tooltip')} onClick={handleClick}>
			<MediaOutline />
		</DecorationButton>
	);
};
